export enum KioskWorkflow
{
	Home,
	Reason,
	Profile,
	WaitingRoom,
	Appointment,
	Finished,
}
